


























import Vue from "vue";
export default Vue.extend({
  props: ["value", "tabs"],
  computed: {
    renderedTabs(): any[] {
      return (this.tabs || []).filter(
        (tab: any) => !(tab.id === "executive" && tab.disable)
      );
    },
  },
});
